/*
 * @Date: 2025-03-03 23:23:45
 * @LastEditors: Wang Xiaomei XianYuPigeon@outlook.com
 * @LastEditTime: 2025-03-06 03:19:18
 * @FilePath: /personal-page/src/config/galleryConfig.ts
 */
/**
 * 图片画廊配置
 * 您可以通过修改这个文件来管理图片与链接的对应关系
 */

export interface GalleryItem {
  /** 图片名称（不含路径，应位于public/images目录下） */
  imageName: string;
  /** 图片显示的标题 */
  title: string;
  /** 点击图片跳转的链接 */
  link: string;
  /** 可选的描述文字 */
  description?: string;
}

/**
 * 画廊配置数组
 * 每一项定义一个图片及其对应的链接和元数据
 * 请确保所有文件都存在于 public/images 目录中
 */
export const galleryItems: GalleryItem[] = [
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/123811857_p0.png',
    title: 'にゃ～',
    link: 'https://www.pixiv.net/artworks/123811857',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/116154666_p0.jpg',
    title: '新スキン甘雨',
    link: 'https://www.pixiv.net/artworks/116154666',
    description: 'さすがに良すぎた…！\n 海灯祭を祝して〜'
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/116149570_p0.jpg',
    title: '新衣装甘雨ちゃん',
    link: 'https://www.pixiv.net/artworks/116149570',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/114061663_p0.png',
    title: '甘雨ちゃんお誕生日！',
    link: 'https://www.pixiv.net/artworks/114061663',
    description: 'おめでとうございました！最近トリプルクラウンになったのであとは最強の聖遺物つけるだけ Twitterも良かったら覗いてみてください！：twitter/uninuinu'
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/114047249_p0.jpg',
    title: 'Ganyu',
    link: 'https://www.pixiv.net/artworks/114047249',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/111673843_p0.jpg',
    title: '白ビキニ甘雨',
    link: 'https://www.pixiv.net/artworks/111673843',
    description: '🌴💙'
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/105378152_p0.jpg',
    title: '『バレンタインですね・・！』',
    link: 'https://www.pixiv.net/artworks/105378152',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/104363720_p0.png',
    title: 'Happy New Year from Ganyu!',
    link: 'https://www.pixiv.net/artworks/104363720',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/103537159_p0.png',
    title: 'ドレス甘雨ちゃん',
    link: 'https://www.pixiv.net/artworks/103537159',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/103261744_p0.png',
    title: '甘雨ちゃん誕生日おめでとう！',
    link: 'https://www.pixiv.net/artworks/103261744',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/101901589_p0.jpg',
    title: '甘雨',
    link: 'https://www.pixiv.net/artworks/101901589',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/99249922_p0.png',
    title: 'ラバスト甘雨ちゃん',
    link: 'https://www.pixiv.net/artworks/99249922',
    description: '当りませんでした'
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/101901589_p0.jpg',
    title: '甘雨',
    link: 'https://www.pixiv.net/artworks/101901589',
    description: ''
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/96242608_p0.png',
    title: 'バレンタイン甘雨ちゃん',
    link: 'https://www.pixiv.net/artworks/96242608',
    description: 'twitter→twitter/mementojai'
  },
  {
    imageName: 'https://files.ganyu.rocks/images/homepage/94115039_p0.jpg',
    title: 'メイド甘雨',
    link: 'https://www.pixiv.net/artworks/94115039',
    description: 'https://twitter.com/g_ya_170/status/1459445941967077382?s=21'
  }
];

// 导出一个函数来检查图片路径是否正确
export function validateImagePath(imageName: string): boolean {
  // 在实际应用中这里可以添加更复杂的逻辑
  return !!imageName && typeof imageName === 'string';
}
// 导出验证函数
export function isValidImageUrl(url: string): boolean {
  // 检查是否是有效的URL
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}